import { enumToByteArray, format, numberToByteArray, stringToByteArray } from '../../utils/utils';
import { DeviceGroupPolicyVaultOperation } from './device-group-policy-vault-operation';
export function getDeviceGroupPolicyVaultEntryBytesToBeSigned(entry) {
    return getDeviceGroupPolicyBytesToBeSigned(entry.entryId, entry.groupId, entry.policyId, entry.replacedPolicyId, entry.policyType, entry.policyHash, entry.addedAt, entry.userId, entry.vaultEntryId, entry.operation, entry.version);
}
export function getDeviceGroupPolicyBytesToBeSigned(entryId, groupId, policyId, replacedPolicyId, policyType, policyHash, addedAt, userId, vaultEntryId, operation, version) {
    const entryIdBytes = numberToByteArray(entryId);
    const buffer = [...entryIdBytes];
    if (operation === DeviceGroupPolicyVaultOperation.AddPolicy || operation === DeviceGroupPolicyVaultOperation.RemovePolicy) {
        buffer.push(...stringToByteArray(groupId));
    }
    if (operation === DeviceGroupPolicyVaultOperation.AddPolicy ||
        operation === DeviceGroupPolicyVaultOperation.ReplacePolicy ||
        operation === DeviceGroupPolicyVaultOperation.RemovePolicy ||
        operation === DeviceGroupPolicyVaultOperation.AddGlobalPolicy ||
        operation === DeviceGroupPolicyVaultOperation.RemoveGlobalPolicy) {
        buffer.push(...stringToByteArray(policyId));
    }
    if (operation === DeviceGroupPolicyVaultOperation.ReplacePolicy) {
        buffer.push(...stringToByteArray(replacedPolicyId));
    }
    if (operation === DeviceGroupPolicyVaultOperation.AddPolicy || operation === DeviceGroupPolicyVaultOperation.AddGlobalPolicy) {
        buffer.push(...enumToByteArray(policyType));
    }
    if (operation === DeviceGroupPolicyVaultOperation.AddPolicy || operation === DeviceGroupPolicyVaultOperation.AddGlobalPolicy || operation === DeviceGroupPolicyVaultOperation.ReplacePolicy) {
        buffer.push(...policyHash);
    }
    const formattedDate = format(addedAt);
    buffer.push(...stringToByteArray(formattedDate));
    buffer.push(...stringToByteArray(userId));
    buffer.push(...numberToByteArray(vaultEntryId));
    buffer.push(...enumToByteArray(operation));
    buffer.push(...numberToByteArray(version));
    return new Uint8Array(buffer);
}
